import { views } from '../constants/views';
import { modes } from '../constants/modes';

export const getStartPeriod = (view, calendarSheet, mode) => {
  if (view) {
    const date = calendarSheet?.clone().startOf(view);

    return view === views.month && mode !== modes.agenda
      ? date.startOf('week')
      : date;
  }

  return undefined;
};

export const getEndPeriod = (view, calendarSheet, mode) => {
  if (view) {
    const date = calendarSheet?.clone().endOf(view);

    return view === views.month && mode !== modes.agenda
      ? date.endOf('week')
      : date;
  }

  return undefined;
};

export const getTotalTime = (view, startPeriod, endPeriod) => {
  if (startPeriod && endPeriod) {
    const diff =
      endPeriod.diff(startPeriod, `${view !== views.day ? 'days' : 'hours'}`) +
      1;

    return diff;
  }

  return undefined;
};
